import { EllipsisVertical } from '@octopus-do/octopus-storybook/icons'
import type { SeoFormValues } from '@store/reducers/seo/types'
import type React from 'react'

import css from './styles.module.css'

export const SearchResults: React.FC<SeoFormValues> = ({
  url,
  title,
  description,
}) => (
  <div className={css.search_results}>
    <div className={css.search_results_text_wrap}>
      <div className={css.search_results_link}>
        <span className={css.search_results_link_text}>{url}</span>
        <EllipsisVertical className={css.search_results_link_icon} />
      </div>
      <div className={css.search_results_title}>{title}</div>
      <div className={css.search_results_description}>{description}</div>
    </div>
  </div>
)
